<template>
  <div class="planes">
    <PlanesPage />
  </div>
</template>

<script>
import PlanesPage from "@/components/PlanesPage.vue";

export default {
  name: "Planes",

  components: {
    PlanesPage,
  },
};
</script>
